import { borderRadiusSm, borderRadiusMd, borderRadiusLg, borderRadiusXl, borderRadius2xl, borderRadius3xl, } from "@airhelp/design-tokens";
const radiuses = {
    sm: borderRadiusSm,
    md: borderRadiusMd,
    lg: borderRadiusLg,
    xl: borderRadiusXl,
    "2xl": borderRadius2xl,
    "3xl": borderRadius3xl,
};
export default radiuses;
